export interface IUserData {
    firstname: string;
    lastname: string;
    bankaccount: string;
    customer: string;
}

export enum DISPLAY_DIRECTION {
    GRID = 1,
    FLEX = 2
}

export enum FC_CONTROLS_USERDATAFROM {
    FIRSTNAME = 'firstname',
    LASTNAME = 'lastname',
    BANKACCOUNT = 'bankaccount',
    CUSTOMER = 'customer'
}
